module.exports = "<div class=app-pan id=app-pan> <div class=input-box> <div class=input-title> <div>审批意见</div> </div> <div class=input-area> <textarea id=app-info></textarea> </div> </div> <div class=btn-box> <div class=sub-btn> 确 定 </div> <div class=cal-btn> 取 消 </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/customPage/showRecord/approve-commonet.html
// module id = 4146
// module chunks = 50